// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e8ec280","698":"61ba6c3d"}[chunkId] + ".chunk.js";
};